import { useState } from 'react';
import { useSwipeable } from 'react-swipeable';

import CarouselCard from '@/atoms/CarouselCard/CarouselCard';

import './Carousel.scss';

const Carousel = () => {
	const cards = [
		'/static/img/feature1.png',
		'/static/img/feature1.png',
		'/static/img/feature1.png',
	];
	const [currentIndex, setCurrentIndex] = useState(0);
	const handlers = useSwipeable({
		onSwipedLeft: () => {
			if (currentIndex >= 0) setCurrentIndex(prevIndex => prevIndex + 1);
			console.log(currentIndex);
		},
		onSwipedRight: () => {
			if (currentIndex <= cards.length - 1)
				setCurrentIndex(prevIndex => prevIndex - 1);
		},
	});
	return (
		<div className='carousel'>
			<h2>Feature Updates</h2>
			<div className='carousel-body' {...handlers}>
				{cards.map((cardUrl, index) => {
					return <CarouselCard key={index} imageUrl={cardUrl} />;
				})}
			</div>
		</div>
	);
};

export default Carousel;
